import React, {useLayoutEffect, useRef} from 'react';

const InternationalPhoneNumberInput = ({inputClassNames, inputWrapperClassNames, defaultNumber, defaultCountry, onChange, inputName, showOptionalPlaceholder}) => {
  const phoneInput = useRef(null);

  useLayoutEffect(() => {
    const intlTelInput = require('intl-tel-input');

    window.iti = intlTelInput(phoneInput.current, {
      initialCountry: defaultCountryIso(),
      customPlaceholder: (selectedCountryPlaceholder, _selectedCountryData) => (
        `${selectedCountryPlaceholder}${showOptionalPlaceholder ? ' (optional)' : ''}`
      ),
    });

    if(defaultNumber) {
      iti.setNumber(defaultNumber);
      handleOnChange();
    }

    phoneInput.current.addEventListener('countrychange', () => {
      handleOnChange();
    });
  }, []);

  const defaultCountryIso = () => (
    {
      'us': 'us',
      'uk': 'gb',
    }[defaultCountry]
  );

  const handleOnChange = () => {
    if (window.iti.isValidNumber() && onChange) onChange(window.iti.getNumber());
  };

  return (
    <>
      <div className={`input-wrapper ${inputWrapperClassNames}`}>
        <input
          className={`rounded border-grey-40 ${inputClassNames}`}
          data-parsley-errors-container='.phone-number-errors-container'
          data-parsley-intl-tel-input-phone-number=''
          id='phoneNumber'
          onChange={handleOnChange}
          ref={phoneInput}
          type='tel'
          {...(inputName ? {name: inputName} : {})}
        />
      </div>
    </>
  );
};

export default InternationalPhoneNumberInput;
